import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import rules from '../../config/rules';

const RuleCriteria = ({ contentType, type, onChange }) => {
    const criteria = rules[contentType.toUpperCase()].find(item => item.criteria === type);

    return (
        <DropdownButton className="rule-criteria" bsStyle="default" title={(criteria || {}).label} onSelect={onChange}>
            {
                rules[contentType.toUpperCase()].map(item => <MenuItem eventKey={item.criteria}>{item.label}</MenuItem>)
            }
        </DropdownButton>
    );
};

export default RuleCriteria;
